import * as React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: '10%',
    paddingRight: '10%',
    marginTop: 220,
    letterSpacing: '0.5px',
    lineHeight: 1.8,
    fontSize: '1.2em',
    '& .MuiTypography-h2': {
      fontWeight: 'bold',
      fontSize: '1.7em',
    },
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      marginTop: 200,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  arrow: {
    position: 'absolute',
    top: -280,
    left: 'calc(50% - 25px)',
    zIndex: 10,
    color: '#ffffff',
    fontSize: 50,
    opacity: 0.75,
    animation: `$no-mover 1s infinite alternate`,
    [theme.breakpoints.down('xs')]: {
      top: -260,
    },
  },
  "@keyframes mover": {
    "0%": { transform: "translateY(0)" },
    "100%": { transform: "translateY(-10px)" }
  }
}));

export default function Guide() {
  const classes = useStyles();
  return (<Container maxWidth="lg"><Box className={classes.root}><a href='#guide'><ExpandMoreIcon className={classes.arrow} /></a>
      <Typography variant="h2"><a name='guide'></a>How to Succeed at a Virtual Recruiting Event</Typography>

    <p>A virtual recruiting event is simply an online space where you can connect directly with companies and their recruiters.</p>
    <p>The primary way you will connect with recruiters is through chat. Recruiters may also have other resource materials for you--videos, documents, Q&amp;A sessions, and other sources of information to assist you in deciding if their company is a fit for you.</p>
    <p>You can attend from a desktop, laptop, tablet or your smartphone. Use should use a current version of a supported browser. We recommend either Mozilla Firefox or Google Chrome.<br/>
      Get Firefox here- <Link href='https://www.mozilla.org/en-US/firefox/new/' target='_blank'>https://www.mozilla.org/en-US/firefox/new/</Link><br/>
      Get Chrome here- <Link href='https://www.google.com/chrome/' target='_blank'>https://www.google.com/chrome/</Link><br/>
    </p>

    <p>Things to do before the event:</p>
    <ul>
      <li>
        <b>Upload a current resume</b><br/>
        If you didn't have access to your resume when you registered, log in prior to the event and click your profile icon in the top-right. This will open the option to add your resume to your profile. Even if you're searching for your first job, every job seeker should have a resume. Need help? Our friends at Wozber.com have a 100% free resume builder that you can use.
      </li>

      <li>
        <b>Do your homework</b><br/>
        Think about the opportunities you want to pursue going into the event. What questions do you want to ask? How can you show a recruiter that you should be their next hire?
      </li>

      <li>
        <b>Dress appropriately</b><br/>
        Some recruiters may invite you to a live video chat, so be prepared to present yourself professionally on camera.
      </li>

      <li>
        <b>Find your happy place</b><br/>
        Shortly prior to logging into the event, make sure you're in a quiet, comfortable place where you can focus on the valuable conversations you'll have with your potential new employer.
      </li>
    </ul>

    <p>Things to do during the event:</p>

    <ul>
      <li>
        <b>Visit every booth</b><br/>
        You never know what opportunities you'll find. Speaking with a recruiter can be eye-opening. You might just be surprised by what you'll discover.
      </li>
      <li>
        <b>Be sure to chat with each exhibitor</b><br/>
        Use the Chat button in each booth to speak with a recruiter at each organization at the event. This is the #1 way to make an impression with recruiters and get answers to your unique questions about their opportunities for which they’re hiring.
      </li>
      <li>
        <b>Interact with live video broadcasts</b><br/>
        Some recruiters will present to all of their booth visitors using a live video broadcast. While they’re live, you can submit questions that only that recruiter can see. Submitting questions is encouraged--this helps the recruiter to better understand the needs of their audience.</li>
      <li>
        <b>Apply to jobs</b><br/>
        Most exhibitors will have posted jobs for which they have the most urgent need to fill. While you’re in each booth, check out the postings and apply to those that are of interest to you.
      </li>
    </ul>
    </Box></Container>);
}
